module.exports = __webpack_public_path__ + "static/media/bell.e996c97f.svg";